<template lang="pug">
.h-scroll(id='scrollHost')
  slot
</template>

<script>
/* eslint-disable no-console, no-unused-vars */
import Velocity from 'velocity-animate';

export default {
  props: {
    currentStep: {
      type: Number,
      default: -1,
    },
  },
  watch: {
    currentStep: {
      deep: true,
      handler() {
        setTimeout(() => {
          const scrollingElement = document.getElementById('scrollHost');

          // WIP: an attempt to a better scroll behavior
          if (this.stepsTarget[this.currentStep] === undefined) {
            this.stepsTarget[this.currentStep] = this.childrenCount;
          }
          this.childrenCount = scrollingElement.children.length;

          // const scrollTarget = scrollingElement.children[this.stepsTarget[this.currentStep]];
          const scrollTarget = scrollingElement.children[scrollingElement.childElementCount - 1];
          // const scrollTargetX = scrollTarget.getBoundingClientRect().left;
          // scrollingElement.scrollTo(scrollTargetX, 0);
          // console.log(JSON.stringify(scrollTarget));
          Velocity(scrollTarget, 'scroll', {
            axis: 'x',
            container: scrollingElement,
            duration: 400,
            easing: 'ease-out',
          });
        }, 100);
      },
    },
  },
  data: () => ({
    childrenCount: 0,
    stepsTarget: {
      0: 0,
      1: 1,
    },
  }),
  mounted() {
    // this.registerDOMMutatedListener();
  },
  method: {
    // registerDOMMutatedListener() {
    //   this.scrollingElement = document.getElementById('scrollHost');

    //   const observer = new MutationObserver((mutations) => {
    //     mutations.forEach((mutation) => {
    //       // console.log('changed!!');
    //       // console.log(scrollingElement.scrollWidth);
    //       this.scrollToTheRight();
    //     });
    //   });

    //   // Pass in the target node, as well as the observer options
    //   observer.observe(this.scrollingElement, {
    //     attributes: true,
    //     childList: true,
    //     characterData: true,
    //   });
    // },
    scrollToTheRight() {
      const scrollingElement = document.getElementById('scrollHost');
      scrollingElement.scrollTo(scrollingElement.scrollWidth, 0);
    },
  },
};
</script>

<style lang="scss">
$card-padding: 12px;

.h-scroll {
  display: flex;

  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  flex-wrap: nowrap;
  padding: $card-padding;
  // scroll-behavior: smooth;

  // scroll-snap-type: x;

  .generic-card {
    // scroll-snap-align: start;
    padding: $card-padding;

    .card {
      max-height: calc(100vh - (#{$card-padding} * 4));   // SCREEN_HEIGHT minus PADDINGs
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
}
</style>
